<template>
  <div>
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :disabled="assignClerkDisabled"
          class="success mr-1"
          fab
          x-small
          v-on="{ ...tooltip }"
          @click="assignClerk()"
        >
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>
      </template>
      <span>ASSIGN CLERK FOR FORMATTING</span>
    </v-tooltip> -->

    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="success mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="assignClerkDisabled"
            @click="assignClerk()"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-format-align-center</v-icon>
              <span class="action-text">ASSIGN CLERK FOR FORMATTING</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>ASSIGN CLERK FOR FORMATTING</span>
    </v-tooltip>
    <div v-if="assignClerkDisabled" class="mt-2 text-center">
      <small class="red--text text--lighten-3">
        {{ assignClerkDisabledMessage }}
      </small>
    </div>

    <!-- THE DIALOG BEGINS HERE -->
    <v-dialog persistent v-model="dialogAssignClerk" max-width="750px">
      <v-card class="text-center">
        <v-card-title class="justify-center text-h5 grey lighten-2">
          <span class="text-h5">ASSIGN CLERK FOR FORMATTING</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="branch.brCode"
                  :items="sortedBranches"
                  item-text="name"
                  item-value="brCode"
                  :menu-props="{ maxHeight: '400' }"
                  label="BRANCH"
                  hint="Select Branch"
                  persistent-hint
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="currentClerk"
                  :items="sortedClerksByBranch(branch.brCode)"
                  item-text="username"
                  item-value="id"
                  no-data-text="There is no Clerk for the branch above"
                  :menu-props="{ maxHeight: '400' }"
                  label="BRANCH CLERK / BRANCH MANAGER / CLERK / MANAGER"
                  hint="Assign Clerk"
                  persistent-hint
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            tile
            dark
            small
            @click="closeAssignClerkDialog"
            class="mt-3 mr-2 error"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :disabled="isFileButtonDisabled"
            small
            class="mt-3 success"
            @click="compAssignClerk"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import MailDataService from "../../services/MailDataService";

import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "AssignClerk",
  props: [
    "subRefTypes",
    "branches",
    "branch",
    "insurer",
    "refType",
    "clerks",
    "management",
    "members",
    "documents",
  ],
  components: {},

  data() {
    return {
      dialogAssignClerk: false,
      currentClerk: "",
    };
  },

  computed: {
    ...mapState(["caseState"]),
    sortedBranches() {
      // Only show branches the user has access to, sorted by name and uppercase
      const user = this.$store.state.auth.user;
      if (!user) return [];
      if (
        user.roles &&
        user.roles.some((role) => ["ADMIN", "MANAGER", "CLERK"].includes(role))
      ) {
        return this.branches
          .map((b) => ({
            ...b,
            name: b.name ? b.name.trim().toUpperCase() : "",
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
      }
      const userBranches = Array.isArray(user.branches)
        ? user.branches
        : [user.branches];
      return this.branches
        .filter((branch) =>
          userBranches.some(
            (userBranch) =>
              userBranch === branch.id ||
              userBranch === Number(branch.id) ||
              userBranch === String(branch.id)
          )
        )
        .map((b) => ({
          ...b,
          name: b.name ? b.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedClerksByBranch() {
      return (brCode) => {
        return this.clerks
          .filter(
            (r) =>
              Array.isArray(r.branches) &&
              r.branches.some((i) => i.brCode === brCode)
          )
          .map((clerk) => ({
            ...clerk,
            username: clerk.username ? clerk.username.trim().toUpperCase() : "",
          }))
          .sort((a, b) => a.username.localeCompare(b.username));
      };
    },
    assignClerkDisabled() {
      // Only disable if not management or case not in formatting stage
      return !(
        (this.caseState.casefile.fileStatus == `PFORM` ||
          this.caseState.casefile.fileStatus == `PEDI`) &&
        this.management
      );
    },

    assignClerkDisabledMessage() {
      if (
        !(
          this.caseState.casefile.fileStatus == `PFORM` ||
          this.caseState.casefile.fileStatus == `PEDI`
        )
      ) {
        return "Case is not in formatting stage";
      }
      if (!this.management) {
        return "You do not have permission to assign clerk";
      }
      return "";
    },

    isFileButtonDisabled() {
      return !(this.branch.brCode && this.currentClerk);
    },
  },
  watch: {
    assignClerk(val) {
      val || this.closeAssignClerkDialog();
    },
    documents: {
      immediate: true,
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },

  methods: {
    // moment: function (date) {
    //   return moment(date);
    // },

    filterBranchName(item) {
      if (!item) return "TBA";
      const filteredbranch = this.branches.filter(
        (branch) => branch.id === item
      );
      return filteredbranch[0].name;
    },
    filterBranches(item) {
      return this.branches.filter((branch) => branch.id === item);
    },

    filterDept(item) {
      return this.refType.filter((dept) => dept.id === item);
    },
    filterSubDept(item) {
      return this.subRefTypes.filter((subRef) => subRef.id === item);
    },
    filterIns(item) {
      return this.insurer.filter((insurer) => insurer.id === item);
    },

    findUserEmail(item) {
      const user = this.members.filter((member) => member.id === item);
      return user[0] ? user[0].email : "sys.admin@associatedadjusters.com";
      // return user.map((b) => b.email);
    },

    filterClerkByBranch(item) {
      return this.clerks.filter((r) =>
        r.branches.some((i) => i.brCode === item)
      );
    },
    assignClerk() {
      this.dialogAssignClerk = true;
    },

    compAssignClerk() {
      CasefileDataService.update(
        this.caseState.casefile.id,
        this.caseState.casefile,
        (this.caseState.casefile.clerkInCharge = this.currentClerk),
        (this.caseState.casefile.fileStatus = `CLERK`),
        (this.caseState.casefile.dateAssignFormatting = moment().format()),
        (this.caseState.casefile.assignClerkBy = this.$store.state.auth.user.id)
      )
        .then((response) => {
          this.closeAssignClerkDialog();
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
        })

        .then(() => {
          var dataEmail = {
            id: this.caseState.casefile.id,
            refType: this.filterDept(this.caseState.casefile.refType)[0]
              .description,
            refTypeCode: this.filterDept(this.caseState.casefile.refType)[0]
              .name,
            subRefType: this.filterSubDept(
              this.caseState.casefile.subRefType
            )[0].subCodeDesc,
            subRefCode: this.filterSubDept(
              this.caseState.casefile.subRefType
            )[0].subCode,
            branch: this.filterBranchName(this.caseState.casefile.branch),
            branchCode: this.filterBranches(this.caseState.casefile.branch)[0]
              .brCode,
            insurer: this.filterIns(this.caseState.casefile.insurer)[0].name,
            vehicleNo: this.caseState.casefile.vehicleNo
              .toLowerCase()
              .replace(/\s/g, ""),
            recipient: this.findUserEmail(this.currentClerk),
            // recipient: branchManager,
            // recipient: branchManager + "," + personInCharge,

            // recipient: this.filterManagerkByBranch(
            //   this.findBrcode(assignedBranch)
            // ),
            createdBy: this.$store.state.auth.user.id,
          };
          MailDataService.assignClerk(dataEmail).then((response) => {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              color: "warning",
              text:
                (response && response.data && response.data.message) ||
                toString(),
            });
          });
          // console.log(JSON.stringify(dataEmail.recipient));
          this.dataEmail = "";
        })

        .catch((e) => {
          console.log(e);
        });

      this.closeAssignClerkDialog();
    },

    closeAssignClerkDialog() {
      this.dialogAssignClerk = false;
      this.$nextTick(() => {});
    },
  },
};
</script>

<style scoped>
.action-text {
  font-size: 0.9rem;
  white-space: normal;
  text-align: center;
  line-height: 1.2;
}
.v-btn.v-btn--disabled {
  opacity: 0.8 !important;
}
.refresh-button {
  font-size: 0.75rem;
}
.check-again-btn {
  text-transform: none;
  letter-spacing: normal;
}
.check-again-btn:hover {
  background-color: rgba(25, 118, 210, 0.08);
}
</style>

<!-- NOTE: This component supports express file movement from PEDI or PFORM when the manager is also the editor and wants to skip the editor assignment/approval process. -->
